import type {
	BCCADMINBaseModelsDeploymentAnalysisIssue,
	BCCADMINBaseModelsDeploymentPageAnalysis,
	BCCADMINBaseModelsPageOutOfSyncItem
} from "../../API/Models";

/** Server response item for GET /api/deployment/page/out-of-sync */
export type PageOutOfSyncItem = { id: string; slug: string; language: string; title?: string | null; pendingReason?: string | null };
export const DEFAULT_LANGUAGE = "fr";

export const normalizeOutOfSyncItem = (item: BCCADMINBaseModelsPageOutOfSyncItem): PageOutOfSyncItem => ({
	id: item.id ?? "",
	slug: item.slug ?? "",
	language: item.language ?? DEFAULT_LANGUAGE,
	title: item.title ?? null,
	pendingReason: item.pendingReason ?? null
});

/** Analysis issue: red = blocks production deploy, orange = warning */
export type DeploymentAnalysisIssue = {
	slug: string;
	language: string;
	severity: "error" | "warning";
	code: string;
	message: string;
};

/** Per-page analysis result for "details for every content-page" */
export type DeploymentPageAnalysis = {
	id: string | null;
	slug: string;
	language: string;
	title: string | null;
	issues: DeploymentAnalysisIssue[];
};

export const normalizeIssue = (issue: BCCADMINBaseModelsDeploymentAnalysisIssue): DeploymentAnalysisIssue => ({
	slug: String(issue.slug ?? ""),
	language: String(issue.language ?? DEFAULT_LANGUAGE),
	severity: issue.severity === "error" ? "error" : "warning",
	code: String(issue.code ?? ""),
	message: String(issue.message ?? "")
});

export const normalizeAnalysis = (item: BCCADMINBaseModelsDeploymentPageAnalysis): DeploymentPageAnalysis => ({
	id: item.id ?? null,
	slug: String(item.slug ?? ""),
	language: String(item.language ?? DEFAULT_LANGUAGE),
	title: item.title ?? null,
	issues: Array.isArray(item.issues) ? item.issues.map((issue) => normalizeIssue(issue)) : []
});

/** Only show View changes / Revert for pages that are actually pending (in the out-of-sync list). */
export const isPending = (pa: DeploymentPageAnalysis, pendingItems: PageOutOfSyncItem[]) =>
	pendingItems.some((i) => i.slug === pa.slug && i.language === pa.language);
